import type { TableColumnsType } from 'ant-design-vue'
/** 产品种类模型 */
export type materialImage = {
  createdAt?: string
  id: number
  image: string
  material_id: number | string
  updatedAt?: string
}
export const MATERIAL_COLUMNS: TableColumnsType = [
  {
    title: '图片',
    dataIndex: 'image',
    width: '15%',
    ellipsis: true,
    align: 'center'
  },
  {
    title: '图片名称',
    dataIndex: 'name',
    width: '15%',
    ellipsis: true,
    align: 'center'
  },
  {
    title: '图片标签',
    dataIndex: 'tag',
    width: '15%',
    ellipsis: false,
    align: 'center'
  },
  {
    title: '图片规格',
    dataIndex: 'specifications',
    width: '25%',
    ellipsis: false,
    align: 'center'
  },
  {
    title: '时间',
    dataIndex: 'time',
    width: '15%',
    ellipsis: false,
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '15%',
    ellipsis: true,
    align: 'center'
  },
]

